module.exports = __webpack_public_path__ + "img/res_layout2.52f0bc61.png";